module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('span', {
    attrs: {
      "aria-label": "page vi",
      "epub:type": "pagebreak",
      "id": "page_vi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page vii",
      "epub:type": "pagebreak",
      "id": "page_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("HISTORIAN’S NOTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The principal events of this story take place shortly after stardate 2258.42, in a parallel reality in which the "), _c('i', [_vm._v("Starship Kelvin")]), _vm._v(" was destroyed in 2233 by a Romulan invader ("), _c('i', [_vm._v("Star Trek,")]), _vm._v(" 2009"), _c('i', [_vm._v(")")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1756a298","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781982140632/xhtml/note.vue
// module id = 72
// module chunks = 0